export default {
  settings: '/catalog/settings/',
  registerUser: '/user/',
  login: '/user/login/',
  logout: '/user/logout/',
  restore_password: '/user/recover-password/',
  activateUser: '/user/activate_user/',
  resetPassword: '/user/reset-password/',
};
